import { render, staticRenderFns } from "./ProductDetailModal.vue?vue&type=template&id=f6e774d4&"
import script from "./ProductDetailModal.vue?vue&type=script&lang=js&"
export * from "./ProductDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports